import { chargbeeController__v1__Factory } from './controller'

/**
 * An object used as an abstraction layer for interaction with Chargebee API and features.
 */

export const ChargebeeController = chargbeeController__v1__Factory.createInstance()